import { DetailsClickToTextBody, DetailsClickToTextHeader } from './Details'
import styles from './styles.module.scss'

export const DetailsClickToTextModalContent = () => {
  return (
    <div className={styles.wrap}>
      <DetailsClickToTextHeader />
      <DetailsClickToTextBody />
    </div>
  )
}
